import React, { useState, useEffect, useRef } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

const containerStyle = {
    width: "100%",
    height: "400px",
    maxWidth: "100%"
};

export const MapView = ({ address }) => {
    const [coordinates, setCoordinates] = useState(null);
    const [geocodeError, setGeocodeError] = useState(false);
    const mapRef = useRef(null);

    const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY
    });

    useEffect(() => {
        if (!isLoaded || !address) return;

        setGeocodeError(false);
        const geocoder = new window.google.maps.Geocoder();

        geocoder.geocode({ address }, (results, status) => {
            if (status === "OK" && results[0]?.geometry?.location) {
                const loc = results[0].geometry.location;
                const coords = { lat: loc.lat(), lng: loc.lng() };
                setCoordinates(coords);
                setGeocodeError(false);
                
                if (mapRef.current) {
                    mapRef.current.panTo(coords);
                }
            } else {
                console.error("Geocode failed:", status);
                setGeocodeError(true);
                setCoordinates(null);
            }
        });
    }, [isLoaded, address]);

    const onLoad = React.useCallback((map) => {
        mapRef.current = map;
    }, []);

    const onUnmount = React.useCallback(() => {
        mapRef.current = null;
    }, []);

    if (loadError || !address || geocodeError) {
        return null;
    }
    
    if (!isLoaded) {
        return <div style={{ padding: '20px' }}>Loading map...</div>;
    }
    
    if (!coordinates) {
        return <div style={{ padding: '20px' }}>Loading map...</div>;
    }

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={coordinates}
            zoom={15}
            onLoad={onLoad}
            onUnmount={onUnmount}
            options={{
                zoomControl: true,
                streetViewControl: false,
                mapTypeControl: false,
                fullscreenControl: true,
            }}
        >
            <Marker position={coordinates} />
        </GoogleMap>
    );
}